import { Injectable } from '@angular/core';

import { saveAs } from 'file-saver-es';

import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class SystemService {
  public copyToClipboard(text: string): void {
    const element: HTMLInputElement = document.createElement('input');
    element.classList.add('hidden');
    element.id = 'copyToClipboard';
    element.value = text;

    document.querySelector('body').appendChild(element);

    element.select();
    document.execCommand('copy');

    document.getElementById('copyToClipboard').remove();
  }

  public readBlob(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.toString());
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  }

  public saveFile(file: File | Blob, filename?: string): void {
    saveAs(file, filename);
  }
}
